import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import { useEffect, useState } from "react";
import IconSearch from "../../../assets/iconSearch";
const SearchDetails = ({ selectedPickupLocation, selectedReturnLocation, setSelectedReturnLocation, t, }) => {
    const currentURL = window.location.href;
    const urlParams = new URLSearchParams(currentURL);
    const [isActive, setIsActive] = useState(false);
    const handleTouchClick = () => {
        setIsActive(!isActive);
    };
    const formatDateDetails = (date, time) => {
        if (!date || !time || date === "null" || time === "null") {
            return null;
        }
        try {
            const momentDate = moment(date + " " + time, "YYYY-MM-DD HH:mm");
            if (!momentDate.isValid()) {
                return null;
            }
            return momentDate
                .format("ddd, D -MMM-, hh:mm a")
                .replace(/\b\w/g, (char) => char.toUpperCase())
                .replace("B", "b")
                .replace(".", "")
                .replace("Pm", "pm")
                .replace("Am", "am")
                .replace("-", "")
                .replace("-", "");
        }
        catch (e) {
            console.error("Error formatting date:", e);
            return null;
        }
    };
    const renderDateTimeSection = () => {
        const pickupDateTime = formatDateDetails(urlParams.get("pickUpDate") || "", urlParams.get("pickUpTime") || "");
        const returnDateTime = formatDateDetails(urlParams.get("returnDate") || "", urlParams.get("returnTime") || "");
        if (!pickupDateTime || !returnDateTime) {
            return null;
        }
        return (_jsxs("div", { className: "searchbar__details-time", children: [_jsx("div", { className: "pickup", children: _jsx("span", { children: pickupDateTime }) }), _jsx("div", { children: _jsx("span", { children: " - " }) }), _jsx("div", { className: "return", children: _jsx("span", { children: returnDateTime }) })] }));
    };
    const className = `button-primary button--bg-gradient-primary264g button--circle ${isActive ? "touched_button_availability" : ""}`;
    const sanitizeParam = (value) => {
        if (!value || value === "undefined" || value === "null")
            return "";
        return value;
    };
    useEffect(() => {
        if (urlParams.get("returnLocName") != "" &&
            urlParams.get("returnLocName") != urlParams.get("pickupLocName")) {
            setSelectedReturnLocation([
                sanitizeParam(urlParams.get("returnLocName")) || selectedReturnLocation[0],
                sanitizeParam(urlParams.get("returnlocation")) || selectedReturnLocation[1],
                sanitizeParam(urlParams.get("returnLocationTypeCode")) || selectedReturnLocation[1],
            ]);
        }
    }, [urlParams.get("returnLocName")]);
    useEffect(() => {
        var _a;
        if (urlParams.get("returnLocName") != "" &&
            urlParams.get("returnLocName") != urlParams.get("pickupLocName")) {
            (_a = document
                .getElementById("search-results")) === null || _a === void 0 ? void 0 : _a.classList.toggle("results--return", true);
        }
    }, [selectedReturnLocation]);
    return (_jsxs("div", { className: "searchbar__details", id: "search_details", children: [_jsxs("div", { className: "searchbar__details-inner", children: [_jsx("div", { className: "searchbar__details-location", children: urlParams.get("pickupLocName") }), urlParams.get("returnLocName") != "" &&
                        urlParams.get("returnLocName") != urlParams.get("pickupLocName") ? (_jsx("div", { className: "searchbar__details-location", children: urlParams.get("returnLocName") })) : null, renderDateTimeSection()] }), _jsx("div", { className: "searchbar__details-search", children: _jsx("button", { className: className, onTouchStart: handleTouchClick, onTouchEnd: handleTouchClick, children: _jsx(IconSearch, {}) }) })] }));
};
export default SearchDetails;
